import { createSlice } from "@reduxjs/toolkit";
export const eventSlice = createSlice({
    name: 'Event',
    initialState: {
        data: {},
        status: false,
        isEdit: false
    },
    reducers: {
        updEventData: (state, action) => {
            const payload = action.payload || {};
            state.data =
                payload.data && !Array.isArray(payload.data) ? payload.data : state.data || {};
            state.status = payload.status ?? state.status;
            state.isEdit = payload.isEdit ?? state.isEdit;
        }
    },
    //extraReducers:
})



export const { updEventData } = eventSlice.actions
export default eventSlice.reducer